import { Button, Input, Form, Typography } from 'antd';
import Localize from '../../utils/string';

const { Title } = Typography;

const Login = () => {
    return (
        <div className="login-page">
            <div className="login-page-inner">
                <Title level={2}>{Localize.ConfirmTitle}</Title>
                <Form name="">
                    <Form.Item
                        name="oldPassword"
                    >
                        <Input.Password placeholder="old password..." />
                    </Form.Item>
                    <Form.Item
                        name="newPassword"
                    >
                        <Input.Password placeholder="new password..." />
                    </Form.Item>
                    <Form.Item  
                        name="renterPassword" 
                    >
                        <Input.Password placeholder="re-enter password..." />
                    </Form.Item>
                    <Button className="rounded-btn" htmlType="submit" shape="circle">{Localize.ConfirmButtonTitle}</Button>
                </Form>
            </div>
        </div >
    )
}

export default Login;